//
import type { ICustomerStore } from './customerStore.model';

export const getDefaultState = (): ICustomerStore => ({
  error: null,
  sendRepEmailError: false,
  loading: {
    investments: false,
    investmentStatements: false,
    retirementCalculator: false,
  },
  investments: {
    groups: [],
    summary: {},
    statements: [],
    calculator: {},
    isCompliant: true,
    samlToken: '',
  },
  customerProfile: {
    country: '',
    customerId: 'null',
    dob: null,
    email: '',
    firstName: '',
    lastName: '',
    mobilePhone: '',
    phoneVerified: false,
    policyIds: [''],
    preferredLang: '',
    ssn: null,
  },
  binaryInvestmentStatement: null,
});

const state = getDefaultState();

export default state;
